import type { WorkbookPanelName } from 'cadenza/workbook/workbook-panel/workbook-panel-utils';
import { togglePanelVisibility } from 'cadenza/workbook/workbook.state';

export const showPanel = (panelId: WorkbookPanelName) => togglePanelVisibility(panelId, true);
export const hidePanel = (panelId: WorkbookPanelName) => togglePanelVisibility(panelId, false);
